import { z } from 'zod';

export const SysAdminLoginInput = z.object({
  email: z.email(),
  senha: z.string().min(1),
});

// A senha vem direto (sys admin não tem reset por e-mail).
export const SysAdminCreateInput = z.object({
  email: z.email(),
  senha: z.string().min(8, 'minimo 8 caracteres'),
});

export type SysAdminOutput = {
  id: string;
  email: string;
  criadoEm: string;
};

export type SysAdminLoginOutput = {
  sysAdmin: SysAdminOutput;
};

export type SysAdminLoginInputType = z.infer<typeof SysAdminLoginInput>;
export type SysAdminCreateInputType = z.infer<typeof SysAdminCreateInput>;
export type SysAdminOutputType = SysAdminOutput;
export type SysAdminLoginOutputType = SysAdminLoginOutput;
